const getters = {
  getSearchExamsState(state) {
    return state;
  }
};

export default getters;
